import { FC, PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/auth.context.tsx';
// import { useThemeStore } from '../store/theme';

const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
	const { isAuthenticated } = useContext(AuthContext);
	// const { is_dark_mode } = useThemeStore();

	// if user is already logged in redirect to home page
	if (isAuthenticated) {
		return (
			<Navigate
				to="/dashboard"
				replace
			/>
		);
	}

	return (
		<section className="dark:bg-dark-bg">
			<div className="container h-dvh px-5 py-10 max-w-screen-lg">
				<div className="grid h-full grid-cols-1 items-center">
					
					<div className="lg:px-28">{children}</div>
				</div>
			</div>
		</section>
	);
};

export default AuthLayout;
